import Stateful from '../reactive/stateful'
import { $ } from 'sitekit'
import on from './on'

class ToolTip extends Stateful {
  constructor (initialFocus = false, template = ``, vars = {}) {
    super({ focus: initialFocus, vars, template })

    this.changed('focus', () => this.renderToolTip()).bind(this)
    this.changed('vars', () => this.renderToolTip()).bind(this)
    this.changed('template', () => this.renderToolTip()).bind(this)

    this.hasAppended = false

    this.tooltip = $(`
      <div 
      id="tooltip"
      class="tooltipper"
      style="
        display: none;
        

      "><!-- The Tooltip -->
      </div>
      `)
  }
  setTemplate (template) {
    this.setState({ template })
  }
  renderToolTip () {
    // console.log(this.state)
    if (this.state.focus) {
      if (!this.hasAppended) {
        $(document.body).append(this.tooltip)
        this.hasAppended = true
      }
      /* 
        Replace <span>{{varName}}</span> with this.state.vars.varName
        */
      var template = Object.entries(this.state.vars || {}).reduce(
        (t, [name, value]) => t.replace(new RegExp(`{{${name}}}`, 'gi'), value),
        this.state.template
      )

      template = template.replace(/!#/g,'')
      this.tooltip.html(template)
      
      this.tooltip.css({ display: '' })

      const targetRect = $(this.state.focus)
        .get(0)
        .getBoundingClientRect()

      const tooltipRect = this.tooltip.get(0).getBoundingClientRect()

      const paddedWidth = tooltipRect.width + 14

      const position =
        targetRect.left > paddedWidth
          ? 'left'
          : window.innerWidth - targetRect.right > paddedWidth
            ? 'right'
            : 'top'

      // console.log(targetRect, paddedWidth)

      this.tooltip.removeClass(['left', 'right', 'top'])
      this.tooltip.addClass(position)

      let css

      /* Position the tooltip */
      if (position === 'left') {
        css = {
          top: targetRect.top + targetRect.height / 2 - tooltipRect.height / 2,
          left: targetRect.left - paddedWidth + 7
        }
      } else if (position === 'right') {
        css = {
          top: targetRect.top + targetRect.height / 2 - tooltipRect.height / 2,
          left: targetRect.right + 7
        }
      } else {
        css = {
          top: targetRect.top - tooltipRect.height - 7,
          left: targetRect.left + targetRect.width / 2 - tooltipRect.width / 2
        }
      }

      this.tooltip.css(css)

      this.onScroll = on($(window), 'scroll resize', () => {
        this.setState({ focus: false })
      })
    } else {
      this.tooltip.css({ display: 'none' })
      this.onScroll && this.onScroll()
    }
  }
  focus (el, vars) {
    const v = vars || {}
    // console.log(el)
    this.setState({ focus: el, vars: { ...this.state.vars, ...v } })
  }
  hide () {
    this.setState({ focus: false })
  }
}

const ToolTipper = new ToolTip()
export default ToolTipper
